import * as $ from "jquery";

export const StrongPasswordRule = (() => {
	$.validator.addMethod("strong", function(value: string, element, errListId) {
		let errors                 = [];
		let errListContainer       = $(errListId);
		let uppercaseCheck: RegExp = /[A-Z]/;
		let lowercaseCheck: RegExp = /[a-z]/;
		let specialCheck: RegExp   = /[!@#$%^&*()\-_=+\[\]{};:,<.>?'"\/~|`]/;
		let numbersCheck: RegExp   = /[0-9]/;

		value.length < 6 && errors.push("przynajmniej 6 znaków");
		!uppercaseCheck.test(value) && errors.push("duże litery");
		!lowercaseCheck.test(value) && errors.push("małe litery");
		!specialCheck.test(value) && errors.push("znaki specjalne");
		!numbersCheck.test(value) && errors.push("liczby");

		if(errListContainer.length == 0) {
			errListContainer = $('<lu>', {id: errListId.replace('#', '')});
			$(element).after(errListContainer);
		}

		errListContainer.empty();
		if (errors.length > 0) {
			errListContainer.show();
			errListContainer.append(`<p>Hasło powinno zawierać:</p>`);
			errors.map(err => {
				errListContainer.append(`<li>${err}</li>`);
			});
			return false;
		}
		errListContainer.hide();
		return true
	}, "Hasło nie spełnia wymagań");
})();import * as $ from "jquery";

export const StrongPasswordRule = (() => {
	$.validator.addMethod("strong", function(value: string, element, errListId) {
		let errors                 = [];
		let errListContainer       = $(errListId);
		let uppercaseCheck: RegExp = /[A-Z]/;
		let lowercaseCheck: RegExp = /[a-z]/;
		let specialCheck: RegExp   = /[!@#$%^&*()\-_=+\[\]{};:,<.>?'"\/~|`]/;
		let numbersCheck: RegExp   = /[0-9]/;

		value.length < 6 && errors.push("przynajmniej 6 znaków");
		!uppercaseCheck.test(value) && errors.push("duże litery");
		!lowercaseCheck.test(value) && errors.push("małe litery");
		!specialCheck.test(value) && errors.push("znaki specjalne");
		!numbersCheck.test(value) && errors.push("liczby");

		if(errListContainer.length == 0) {
			errListContainer = $('<lu>', {id: errListId.replace('#', '')});
			$(element).after(errListContainer);
		}

		errListContainer.empty();
		if (errors.length > 0) {
			errListContainer.show();
			errListContainer.append(`<p>Hasło powinno zawierać:</p>`);
			errors.map(err => {
				errListContainer.append(`<li>${err}</li>`);
			});
			return false;
		}
		errListContainer.hide();
		return true
	}, "Hasło nie spełnia wymagań");
})();